import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maquinas-consulta-censo',
  templateUrl: './maquinas-consulta-censo.component.html',
  styleUrls: ['./maquinas-consulta-censo.component.scss']
})
export class MaquinasConsultaCensoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
